import { useCallback, useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Platform, Pressable, StyleSheet } from 'react-native';
import { View } from '@/components/Themed';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppUtilities from '@/utilities/AppUtilities';
import { CustomText } from '@/components/CustomText';
import { Button, Hourglass } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setData } from '@/state/user';
import { RelativePathString, router, useRouter, useLocalSearchParams, useNavigation, Link } from 'expo-router';
import Footer from '@/components/Footer';
import { CommunityMembership, UNKNOWN_COMMUNITY_MEMBERSHIP } from "@/types/community_membership";
import * as AppConstants from '@/utilities/AppConstants';
import Profile from '@/components/Profile';
import { AppContext } from '@/components/AppContext';
import { Chat, Message, User, Send, Day, Time, PartialChatTheme } from '@kesha-antonov/react-native-chat';
//import { Chat, Message, User, Send, Day, Time, PartialChatTheme } from 'react-native-chat-rabbl';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useHeaderHeight } from "expo-router/react-navigation";
import { Image } from 'expo-image';
import { MatchMessage, MessageType } from '@/types/match_message';
import { Drawer } from 'react-native-drawer-layout';
import { BasicScrollView } from '@/components/BasicScrollView';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  image: {
    width: 200,
    height: 200,
  },
  bottomLeft: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    backgroundColor: 'transparent',
  },
  bottomRight: {
    position: 'absolute',
    bottom: 30,
    right: 30,
    backgroundColor: 'transparent',
  },
  imageWrapper: {
    backgroundColor: 'transparent',
  },
  wrapper: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  decisionImage: {
    width: 64,
    height: 64,
  },
  decisionWrapper: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    width: '100%',
    gap: 40,
    position: 'absolute',
    bottom: 0,
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 19,
    backgroundColor: 'transparent',
  },
  largeAvatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: 'transparent',
  },
  header: {
    padding: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
    gap: 20,
  },
  emptyContainer: {
    padding: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
    gap: 20,
  },
  sendButton: {
    marginRight: 2,
    marginBottom: 7,
  },
  headerRightIcon: {
    width: 13,
    height: 13,
    marginVertical: 10,
    marginHorizontal: 20,
  },
  headerRightIcon2: {
    width: 16,
    height: 16,
    marginVertical: 10,
    marginHorizontal: 20,
  },
  headerRightIcon3: {
    width: 15,
    height: 15,
    marginVertical: 10,
    marginHorizontal: 20,
  },
  topView: {
    gap: 20,
    alignItems: 'center',
  },
  scrollView: {
    padding: 20,
    paddingTop: 20,
    flexGrow: 1,
    gap: 5,
  },
  closeIconView: {
    width: "100%",
    flexDirection: 'row',
    justifyContent: 'flex-end',
    //paddingTop: 10,
  },
  closeIconWrapper: {
    margin: 10,
    width: 8,
    height: 7,
  },
});

export default function ShowChat() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const { chat_match_id } = useLocalSearchParams<{ chat_match_id: string }>();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [member, setMember] = useState<CommunityMembership>(UNKNOWN_COMMUNITY_MEMBERSHIP);
  const [memberUser, setMemberUser] = useState<User>();
  const [otherMember, setOtherMember] = useState<CommunityMembership | null>(UNKNOWN_COMMUNITY_MEMBERSHIP);
  const [otherMemberUser, setOtherMemberUser] = useState<User>();
  const [firstLoadFinished, setFirstLoadFinished] = useState(false);
  const dispatch = useDispatch();
  const [messages, setMessages] = useState<MatchMessage[]>([]);
  const router = useRouter();
  const navigation = useNavigation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // https://github.com/kesha-antonov/react-native-chat?tab=readme-ov-file#understanding-keyboardverticaloffset
  const insets = useSafeAreaInsets();
  //const keyboardTopToolbarHeight = Platform.select({ ios: 44, default: 0 });
  const headerHeight = useHeaderHeight();
  const keyboardVerticalOffset = headerHeight;

  useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Pressable onPress={() => setDrawerOpen(!drawerOpen)}>
          {/*
          <Image
            style={styles.headerRightIcon}
            source={require('@/assets/images/PixelarticonsMessageProcessing13x13.png')}
          />
          */}
          <Image
            //style={styles.headerRightIcon2}
            //source={require('@/assets/images/minis/gears.png')}
            style={styles.headerRightIcon3}
            source={require('@/assets/images/minis/sayheart.gif')}
          />
        </Pressable>
      ),
    });
  }, [navigation, drawerOpen]);

  const loadInitialData = useCallback(async () => {
    try {
      setLoading(true);
      setError('');

      const response = await AppUtilities.fetchAuthorized(
        "ShowChat.loadInitialData",
        "/rabbl/api/chat",
        "POST",
        {
          domain: domain,
          id: chat_match_id,
        }
      );

      dispatch(setData(response));

      const memberResult: CommunityMembership = ((response as any).body as any).community_membership;
      const otherMemberResult: CommunityMembership = ((response as any).body as any).other_community_membership;

      AppUtilities.info("ShowChat.loadInitialData members:");
      AppUtilities.dir(memberResult);
      AppUtilities.dir(otherMemberResult);

      setMember(memberResult);
      const memberUserResult : User = {
        _id: memberResult.uniqueid,
        name: memberResult.profile.name,
        avatar: memberResult.profile.visuals[0].uniqueid,
      };
      setMemberUser(memberUserResult);

      setOtherMember(otherMemberResult);

      const otherMemberUserResult : User =
        otherMemberResult ?
            {
              _id: otherMemberResult.uniqueid,
              name: otherMemberResult.profile.name,
              avatar: otherMemberResult.profile.visuals[0].uniqueid,
            }
          :
            {
              _id: "-1",
              name: AppConsts.DELETED_USER,
              avatar: "",
            }
      ;

      setOtherMemberUser(otherMemberUserResult);

      const messagesResult: MatchMessage[] = ((response as any).body as any).messages;
      messagesResult.forEach((m: MatchMessage) => {
        if (m.source_uniqueid != memberResult.uniqueid) {
          m.user = otherMemberUserResult;
        } else {
          m.user = memberUserResult;
        }
      });

      setMessages(messagesResult);
      setFirstLoadFinished(true);
    } catch (e) {
      AppUtilities.handleException(e, "ShowChat.loadInitialData");
      setError(AppUtilities.getErrors(e));
    } finally {
      setLoading(false);
    }
  }, [domain, chat_match_id]);

  useEffect(() => {
    if (chat_match_id) {
      loadInitialData();
    }
  }, [domain, chat_match_id]);

  useEffect(() => {
    if (domain && chat_match_id && member && memberUser && otherMember && otherMemberUser && firstLoadFinished) {
      const interval = setInterval(async () => {
        try {
          if (AppUtilities.DEBUGLEVEL.dev) {
            //AppUtilities.info("chat/[id] refresh " + id);
          }
          const response = await AppUtilities.fetchAuthorized(
            "chat/[id] refresh",
            "/rabbl/api/chat",
            "POST",
            {
              domain: domain,
              id: chat_match_id,
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now
              lastChecked: Date.now() - AppConsts.REFRESH_INTERVAL_CHAT_REFRESH_MS,
            },
            null,
            false,
            false,
            true,
          );

          dispatch(setData(response));

          const messagesResult: MatchMessage[] = ((response as any).body as any).messages;
          if (messagesResult) {
            if (AppUtilities.DEBUGLEVEL.dev) {
              AppUtilities.info("chat/[id] updating messages");
            }
            messagesResult.forEach((m: MatchMessage) => {
              if (m.source_uniqueid != member.uniqueid) {
                m.user = otherMemberUser;
              } else {
                m.user = memberUser;
              }
            });
            setMessages(messagesResult);
          }

        } catch (e) {
          if (AppUtilities.DEBUGLEVEL.extra) {
            AppUtilities.dir(e);
          }
        }

      }, AppConsts.REFRESH_INTERVAL_CHAT_REFRESH_MS);

      return () => {
        clearInterval(interval);
      };
    }
  }, [domain, chat_match_id, firstLoadFinished, member, memberUser, otherMember, otherMemberUser]);

  const onSend = useCallback(async (messagesToSend: MatchMessage[] = []) => {
    try {
      showSpinner();
      AppUtilities.info("ShowChat.onSend started");
      const response = await AppUtilities.fetchAuthorized(
        "ShowChat.onSend",
        "/rabbl/api/sendmessages",
        "POST",
        {
          domain: domain,
          id: chat_match_id,
          messages: messagesToSend,
        }
      );
      AppUtilities.info("ShowChat.onSend finished:");
      setMessages((previousMessages) =>
        Chat.append<MatchMessage>(previousMessages, messagesToSend)
      );
    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSend(messagesToSend), true);
      AppUtilities.handleException(e, "ShowChat.onSend");
    } finally {
      hideSpinner();
    }
  }, [domain, chat_match_id]);

  const unmatch = useCallback(async (decisionType: string) => {
    let doHideSpinner = true;
    try {
      showSpinner();
      const response = await AppUtilities.fetchAuthorized(
        "ShowChat.unmatch",
        "/rabbl/api/unmatch",
        "POST",
        {
          domain: domain,
          id: chat_match_id,
          decisionType: decisionType,
        }
      );
      dispatch(setData(response));
      doHideSpinner = AppUtils.closeDrawerActionState(
        () => {
          if (router.canGoBack()) {
            router.back();
          } else {
            router.navigate('/chats');
          }
        },
        hideSpinner,
        setDrawerOpen,
      );
    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => unmatch(decisionType), true);
      AppUtilities.handleException(e, "ShowChat.unmatch");
    } finally {
      if (doHideSpinner) {
        hideSpinner();
      }
    }
  }, [domain, chat_match_id]);

  if (loading) {
    return (
      <View style={AppConstants.STYLES.container2}>
        <Hourglass size={AppConstants.LARGE_HOURGLASS_SIZE} />
      </View>
    );
  }

  if (error.length > 0) {
    return (
      <View style={AppConstants.STYLES.container2}>
        <CustomText>Failed to load</CustomText>
        <AppText>{error}</AppText>
        <Button onPress={loadInitialData}>Retry</Button>
      </View>
    );
  }

  // https://github.com/kesha-antonov/react-native-chat/blob/main/src/Theme.ts
  const theme : PartialChatTheme = {
    colors: {
      background: "transparent",
      inputBackground: "transparent",
    },
    radii: {
      inputField: 0,
    },
    composer: {
      fieldPaddingH: 0,
    },
    spacing: {
      inputToolbarPaddingV: 0,
      screenEdge: {
        right: 4,
      },
    }
  };

  return (
    <Drawer
      open={drawerOpen}
      onOpen={() => setDrawerOpen(true)}
      onClose={() => setDrawerOpen(false)}
      drawerPosition="right"
      renderDrawerContent={() => {
        return (
          <BasicScrollView center={false} overrideStyle={true} contentContainerStyle={styles.scrollView}>
            <View style={styles.closeIconView}>
              <Pressable onPress={() => setDrawerOpen(false)}>
                <Image source={require("@/assets/images/close8x7.png")} style={styles.closeIconWrapper} />
              </Pressable>
            </View>
            <View style={styles.topView}>
              <CustomText>{otherMember?.profile.name ?? AppConsts.DELETED_USER}</CustomText>
              <Button onPress={() => unmatch("normal")}>Unmatch</Button>
              {/*<Button onPress={() => unmatch("block")}>Block</Button>*/}
              <Button onPress={() => unmatch("report")}>Report</Button>
            </View>
          </BasicScrollView>
        );
      }}
    >
      <View style={[styles.wrapper, { paddingBottom: insets.bottom }]}>
        <Meta title={otherMember?.profile.name ?? AppConsts.DELETED_USER} />
        <Chat
          messages={messages}
          onSend={onSend}
          user={memberUser}
          isMultiline={false}
          keyboardAvoidingViewProps={{ keyboardVerticalOffset }}
          isSendButtonAlwaysVisible={true}
          textInputProps={{
            style: AppConstants.STYLES.defaultFont,
          }}
          isUserAvatarVisible={true}
          theme={theme}
          darkTheme={theme}
          renderSend={(props) => (
            <Button
              onPress={() => {
                if (props.onSend && props.text) {
                  props.onSend(
                    {
                      text: props.text
                    },
                    true
                  );
                }
              }}
              style={styles.sendButton}
              disabled={!otherMember || props.text?.length == 0}
            >Send</Button>
          )}
          messageTextProps={{
            customTextStyle: AppConstants.STYLES.defaultFont,
            //phone: false,
            //email: false,
            //url: false,
            mention: false,
            hashtag: false,
          }}
          renderDay={(props) => (
            <Day
              {...props}
              //textStyle={AppConstants.STYLES.defaultFont}
            />
          )}
          renderTime={(props) => (
            <Time
              {...props}
              timeTextStyle={{
                left: AppConstants.STYLES.defaultFont,
                right: AppConstants.STYLES.defaultFont
              }} />
          )}
          renderMessage={(props) => {
            if (AppUtilities.DEBUGLEVEL.dev) {
              //AppUtilities.info("Message:");
              //AppUtilities.dir(props.currentMessage);
            }

            // Probably a system message since a user can't send a blank message
            if (props.currentMessage.text == "") {
              return <View />;
            }
            return <Message {...props} />;
          }}
          renderAvatar={(avatar) => {
            const avatarId = avatar.currentMessage.user.avatar ?? "";
            return (
              <Link href={('/profile/' + avatar.currentMessage.user._id + '?d=n') as RelativePathString} asChild={AppUtilities.isWeb()}>
                <Image
                  source={avatarId == "" ? require('@/assets/images/PixelarticonsUser80x80.png') : { uri: AppUtils.createBackendLink('/rabbl/api/visual?thumbnail=yes&uniqueid=' + avatarId) }}
                  style={styles.avatar}
                />
              </Link>
            );
          }}
          enableGestureHandlerRootView={false}
          listProps={{
            // The first two "messages" are just the "matched" messages
            inverted: messages.length > 2,
            ListFooterComponent: (
              <View style={styles.header}>
                <CustomText>{otherMember?.profile.name ?? AppConsts.DELETED_USER}</CustomText>
                <Link href={('/profile/' + otherMember?.uniqueid + '?d=n') as RelativePathString} asChild={AppUtilities.isWeb()}>
                  <Image
                    source={
                      otherMember ?
                          { uri: AppUtils.createBackendLink('/rabbl/api/visual?thumbnail=yes&uniqueid=' + otherMember.profile.visuals[0].uniqueid) }
                        :
                          require('@/assets/images/PixelarticonsUser80x80.png')
                    }
                    style={styles.largeAvatar}
                  />
                </Link>
                {
                  messages.length == 0 && (
                    <View style={styles.emptyContainer}>
                      <AppText>Send the first message below</AppText>
                    </View>
                  )
                }
              </View>
            )
          }}
        />
      </View>
    </Drawer>
  );
}
